@let ratingValue = rating();

<div class="skill-rating" [class]="status()" layout layout-wrap layout-align-items-center>
  @for (position of scale(); track position) {
    <div
      [class.filled]="position <= (ratingValue.ratedProficiencyPosition || 0)"
      [class.expected]="position === (ratingValue.expectedProficiencyPosition || 0)"
      [rtTooltip]="'app.interview.summary.skills_summary.expected_proficiency_tooltip' | translate"
      [rtTooltipEnabled]="position === (ratingValue.expectedProficiencyPosition || 0)"
      class="skill-leaf-container"
      layout
    >
      <span class="skill-leaf"></span>
    </div>
  }
</div>

<div layout>
  <span
    [rtTooltip]="ratingValue.ratedProficiencyName"
    [rtTooltipEnableWhenTruncated]="true"
    class="skill-proficiency-name"
    >{{ ratingValue.ratedProficiencyName }}</span
  >
</div>
